import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Checkbox from '../../atoms/Checkbox';
import Font from '../../atoms/Font';
import Icon from '../../atoms/Icon';
import {
  OptionalServicesItemTitle,
  OptionalServicesItemWrapper,
  OptionalServicesListWrapper,
  OptionalServicesTitle,
  OptionalServicesWrapper,
  SelectedSection,
  TextSelectionWrapper
} from './styles';

type OptionalService = {
  isSelected?: boolean;
  name: string;
  value: number;
};

const optionalServices: OptionalService[] = [
  {
    name: 'Property tax',
    value: 1500
  },
  {
    name: 'Tire Replacement Service',
    value: 500
  },
  {
    name: 'Courtesy car',
    value: 800
  },
  {
    name: 'Leasys Be Safe',
    value: 2000
  }
];

const OptionalServices = ({ list = optionalServices }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState<OptionalService[]>([]);
  const [internalList, setInternalList] = useState(list);

  const handleOpen = () => {
    setOpen(!open);
  };

  useEffect(() => {
    setInternalList(list.map((item) => ({ ...item, isSelected: false })));
  }, [list]);

  const giveServicesValue = () =>
    selected.reduce((acc: number, item: any) => acc + item.value, 0);

  const handleSelectRemove = (item: OptionalService) => {
    setSelected(
      selected.find((selectedItem) => selectedItem.name === item.name)
        ? selected.filter((selectedItem) => selectedItem.name !== item.name)
        : [...selected, item]
    );
  };

  return (
    <OptionalServicesWrapper>
      <OptionalServicesTitle $isOpen={open}>
        <Font variant="bodyBold">{t('OptionalServicesTitle')}</Font>
        <SelectedSection>
          {selected.length > 0 && (
            <TextSelectionWrapper>
              <Font variant="bodyBold">{selected.length}</Font>
              <Font variant="bodyRegular">{t('ServicesSelected')} -</Font>
              <Font variant="bodyBold">
                {`${giveServicesValue()} ${t('Currency')}`}
              </Font>
            </TextSelectionWrapper>
          )}
          <Icon
            iconName={open ? 'InterfaceChevronUp' : 'InterfaceChevronDown'}
            onClick={handleOpen}
          />
        </SelectedSection>
      </OptionalServicesTitle>
      {open && (
        <OptionalServicesListWrapper>
          {internalList.map((item) => (
            <OptionalServicesItemWrapper
              key={item.name}
              onClick={() => handleSelectRemove(item)}
            >
              <Checkbox
                isChecked={
                  !!selected.find(
                    (selectedItem) => selectedItem.name === item.name
                  )
                }
                onChange={() => handleSelectRemove(item)}
              />
              <OptionalServicesItemTitle>
                <Font variant="bodyRegular">{item.name}</Font>
              </OptionalServicesItemTitle>
              <Font variant="bodyBold">{`${item.value} ${t('Currency')}`}</Font>
            </OptionalServicesItemWrapper>
          ))}
        </OptionalServicesListWrapper>
      )}
    </OptionalServicesWrapper>
  );
};

export default OptionalServices;
